import React, { useState } from 'react';
import { Lock, ArrowRight, AlertCircle } from 'lucide-react';

export const isAuthenticated = () => {
  const ts = localStorage.getItem('tk_auth_ts');
  if (!ts || localStorage.getItem('tk_authenticated') !== 'true') return false;
  const elapsed = Date.now() - parseInt(ts, 10);
  if (elapsed > 24 * 60 * 60 * 1000) {
    localStorage.removeItem('tk_authenticated');
    localStorage.removeItem('tk_auth_ts');
    return false;
  }
  return true;
};
export const logout = () => {
  localStorage.removeItem('tk_authenticated');
  localStorage.removeItem('tk_auth_ts');
};

const LoginScreen = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    setTimeout(() => {
      if (password === process.env.REACT_APP_AUTH_PASSWORD) {
        localStorage.setItem('tk_authenticated', 'true');
        localStorage.setItem('tk_auth_ts', String(Date.now()));
        onLogin();
      } else {
        setError('Incorrect password');
        setLoading(false);
      }
    }, 400);
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="flex flex-col items-center mb-10">
          <img
            src="/the-knight-logo.png"
            alt="The Knight"
            data-testid="login-logo"
            className="w-16 h-16 object-contain mb-4"
          />
          <h1 className="text-xl font-bold text-[#171717] font-heading tracking-tight">TK Analytics</h1>
          <p className="text-sm text-[#737373] mt-1">Enter your password to continue</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="bg-white rounded-[10px] border border-[#E5E5E5] p-6 shadow-[0_2px_10px_rgba(0,0,0,0.02)]">
          <div className="mb-4">
            <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#737373] mb-2">Password</label>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#A3A3A3]" />
              <input
                data-testid="password-input"
                type="password"
                value={password}
                onChange={e => { setPassword(e.target.value); setError(''); }}
                placeholder="Enter access password"
                className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-[#E5E5E5] text-sm text-[#171717] placeholder-[#A3A3A3] focus:outline-none focus:border-[#171717] focus:ring-1 focus:ring-[#171717]/10 transition-colors"
                autoFocus
              />
            </div>
          </div>

          {error && (
            <div className="flex items-center gap-2 px-3 py-2 mb-4 rounded-lg bg-red-50 border border-red-200">
              <AlertCircle className="w-3.5 h-3.5 text-red-500 flex-shrink-0" />
              <span className="text-xs text-red-600 font-medium">{error}</span>
            </div>
          )}

          <button
            data-testid="login-button"
            type="submit"
            disabled={!password || loading}
            className={`w-full flex items-center justify-center gap-2 py-2.5 rounded-lg text-sm font-semibold transition-all
              ${password
                ? 'bg-[#171717] text-white hover:bg-[#2a2a2a]'
                : 'bg-[#E5E5E5] text-[#A3A3A3] cursor-not-allowed'
              }`}
          >
            {loading ? (
              <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : (
              <>
                Continue
                <ArrowRight className="w-4 h-4" />
              </>
            )}
          </button>
        </form>

        <p className="text-center text-[10px] text-[#A3A3A3] mt-6">Protected by TK Analytics</p>
      </div>
    </div>
  );
};

export default LoginScreen;
